import * as d3 from 'd3';
import { lloydConstants } from './Constants';

// Colour scales live here rather than in the chart so the legends colour their
// swatches from exactly the same functions the shapes are filled with. When they
// were defined in the chart, a change to one silently disagreed with the other.

const build = ({ low, mid, high }) => ({
	resilience: d3.scaleDiverging().domain([20, 55, 100]).range([low, mid, high]),
	categorical: d3.scaleDiverging().domain([0, 0.3, 0.75]).range([low, mid, high]),
	// Change between waves is symmetric about zero. Five points is a large move.
	change: d3.scaleDiverging().domain([-5, 0, 5]).range([low, mid, high]),
	// Wide interval to narrow interval, so an imprecise estimate cannot look
	// as authoritative as a precise one.
	precision: d3.scaleSequential().domain([6, 1]).interpolator(d3.interpolateGreys).clamp(true),
});

const brand = build(lloydConstants.palettes.brand);
const colourBlindSafe = build(lloydConstants.palettes.colourBlindSafe);

export const scaleFor = (safe) => (safe ? colourBlindSafe : brand);

// Kept for the legends, which want the resilience and income ramps by name.
export const divergingScale = brand.resilience;
export const categoricalScale = brand.categorical;
